export default __webpack_public_path__ + "static/decoration-01-9ef8bba5a1efc76a636207c4f7cb684a.svg";